import React, { useState } from "react";
import { FaGoogle, FaApple } from "react-icons/fa";
import { MdEmail, MdLock, MdVisibility, MdVisibilityOff } from "react-icons/md";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import "../style/login.css";
import { loginWithEmail } from "../services/loginService";
import RestablecerPorCorreo from "../components/restablecercorreo";

const LoginPage = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [showResetModal, setShowResetModal] = useState(false);
    const [resetOption, setResetOption] = useState(null);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const togglePassword = () => setShowPassword(!showPassword);

    const handleResetContinue = (opcion) => setResetOption(opcion);


    const handleLoginEmail = async (e) => {
        e.preventDefault();
        if (!email || !password) {
            alert("Ingresa correo y contraseña");
            return;
        }
        try {
            setLoading(true);
            const res = await loginWithEmail(email, password);
            if (res?.data?.success) {
                localStorage.setItem("token", res.data.token);
                localStorage.setItem("user", JSON.stringify(res.data.user));
                window.location.href = "/dashboard";
            }
        } catch (err) {
            if (err.message.includes("No se pudo conectar al servidor")) {
                alert("Error: El servidor no está disponible. Verifica que esté corriendo.");
            } else {
                alert(err.response?.data?.message || "Error al iniciar sesión");
            }
        } finally {
            setLoading(false);
        }
    };

    const handleGoogleSuccess = async (credentialResponse) => {
        try {
            const res = await fetch("https://agro-nexus-prod.vercel.app/auth/google", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token: credentialResponse.credential }),
            });

            const data = await res.json();
            if (data.success) {
                localStorage.setItem("token", data.token);
                localStorage.setItem("user", JSON.stringify(data.user));
                window.location.href = "/dashboard";
            } else {
                alert("Error con Google Login");
            }
        } catch (error) {
            console.error(error);
            alert("Error al conectar con Google Login");
        }
    };

    const renderForm = () => {
        if (resetOption === "correo") {
            return <RestablecerPorCorreo onClose={() => setResetOption(null)} />;
        }
        return (
            <>
                <label>Correo electrónico</label>
                <div className="input-wrapper">
                    <MdEmail />
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Ingresa tu correo"
                        required
                        autoComplete="email"
                    />
                </div>

                <label>Contraseña</label>
                <div className="input-wrapper">
                    <MdLock />
                    <input
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Ingresa tu contraseña"
                        required
                        autoComplete="current-password"
                    />
                    <span
                        className="eye-icon"
                        onClick={togglePassword}
                        role="button"
                        tabIndex={0}
                    >
                        {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                    </span>
                </div>

                <div className="login-options">
                    <label>
                        <input type="checkbox" /> Recuérdame
                    </label>
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            setShowResetModal(true);
                        }}
                    >
                        ¿Olvidaste tu contraseña?
                    </a>
                </div>

                <button
                    type="submit"
                    className="signin-btn"
                    onClick={handleLoginEmail}
                    disabled={loading}
                >
                    {loading ? "Ingresando..." : "Iniciar sesión"}
                </button>
            </>
        );
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <h2 className="login-title">Iniciar Sesión</h2>
                <p className="login-subtitle">
                    Bienvenido de nuevo a <strong>AgroNexus</strong>
                </p>
                <p className="login-subtext">Por favor, inicia sesión con tu cuenta</p>

                <form className="login-form">{renderForm()}</form>

                {!resetOption && (
                    <div className="footer-links">
                        <p>
                            ¿No tienes una cuenta? <a href="/registro">Regístrate</a>
                        </p>
                        <p className="or-text">O ingresa con</p>
                        <div className="social-buttons">
                            {/* LOGIN GOOGLE */}
                            <GoogleOAuthProvider clientId="TU_CLIENT_ID_GOOGLE">
                                <GoogleLogin
                                    onSuccess={handleGoogleSuccess}
                                    onError={() =>
                                        alert("Error al iniciar sesión con Google")
                                    }
                                />
                            </GoogleOAuthProvider>

                            <button
                                className="provider-btn apple"
                                type="button"
                                onClick={() =>
                                (window.location.href =
                                    "https://agro-nexus-prod.vercel.app/auth/apple")
                                }
                            >
                                <FaApple /> Apple
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {showResetModal && (
                <RestablecerPorCorreo
                    onClose={() => setShowResetModal(false)}
                    onContinue={handleResetContinue}
                />
            )}
        </div>
    );
};

export default LoginPage;
